import { API_URL } from "@/config/api";
import axios, { AxiosError, AxiosInstance } from "axios";

const BASE_URL = API_URL + "/api/v1";

const applyInterceptors = (instance: AxiosInstance): AxiosInstance => {
  instance.interceptors.response.use(
    (response) => response.data,
    (error: AxiosError) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        console.error("Authentication error:", error.response.status);
      }

      if (!error.response) {
        console.error("Network error:", error.message);
      }

      return Promise.reject(error);
    }
  );
  return instance;
};

const createApiInstance = (prefix = ""): AxiosInstance =>
  applyInterceptors(
    axios.create({
      baseURL: `${BASE_URL}${prefix}`,
      withCredentials: true,
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
      },
    })
  );

export const cmsApi = createApiInstance("/cms");

const api = createApiInstance();
export default api;
